
import React, { useEffect, useRef, useState } from 'react';
import { Ibox, Table, ModalAlert } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import * as actions_assets from 'actions/assets-actions';

const AssetsTab = (props) => {

    /* Hooks --------------------------*/

    const ref = useRef();
    const assets = useSelector((store) => store.assets.assets);
    const associatedAssets = assets?.filter((asset) => asset.parts?.includes(props.match.params.stock_part_id));
    const assetOptions = assets?.filter((asset) => asset.assetType == props.match.params.asset_type_id && !asset.parts?.includes(props.match.params.stock_part_id));
    const [newItem, setNewItem] = useState();
    const dispatch = useDispatch();

    /* Effects --------------------------*/

    useEffect(() => {
        if (newItem) { ref.current.setNewItem(prev => ({ ...prev, id: newItem?.name })); }
    }, [newItem?.name]);

    /* Handlers --------------------------*/

    const handleSaveNew = (newItem) => { dispatch(actions_assets.saveStockPartToAsset(props.match.params.handle, newItem.id, props.match.params.stock_part_id)); };

    const confirmDelete = (item) => {
        ModalAlert({
            title: 'Are you sure?',
            text: "The Stock Part will be removed from this Asset's catalog.",
            icon: 'warning',
            show_cancel: true,
            confirm_color: '#8FBC8B',
            confirm_text: 'Yes, remove it!',
            callback_success: () => handleDelete(item),
        });
    };

    const handleDelete = (item) => { dispatch(actions_assets.saveStockPartToAsset(props.match.params.handle, item.id, props.match.params.stock_part_id, true)); };

    /* Constants --------------------------*/

    const columns = [
        { name: "Unit #", field: "id", width: 20 },
        { name: "Asset Name", field: "name", width: 80, valid: ['required'], edit: { noEdit: true, type: 'select', options: [{ label: '- Select -', }, ...(assetOptions ?? [])?.map((asset) => ({ value: asset.id, label: asset.name }))] } },
    ];


    return (
        <Ibox title='Assets'>
            <Table
                ref={ref}
                button={" + Asset "}
                button_in_ibox={true}
                button_callback={() => ({})}
                button_disabled={(!assetOptions?.length)}
                columns={columns}
                data={associatedAssets}
                delete={true}
                on_delete={confirmDelete}
                highlight_search={true}
                limit={10}
                save_new_callback={handleSaveNew}
                show_search={true}
                saveNewOnly={true}
                onNewItemChanged={(newItem) => setNewItem(newItem)}

            >
            </Table>
        </Ibox>
    );
};

export default AssetsTab;